// زمانِ تقریبیِ یه سیگنال («این آخر هفته»، «شنبه حدود ۱۹»).
//
// قبلاً متنِ **رندرشده** ذخیره می‌شد. یعنی اگه فرستنده فارسی بود، گیرنده‌ی
// انگلیسی‌زبان هم «شنبه حدود ۱۹:۰۰» می‌دید — چون رشته‌ای که توی دیتابیس نشسته
// بود دیگه ترجمه‌پذیر نبود.
//
// حالا یه نشانه‌ی ماشین‌خوان ذخیره میشه و ترجمه موقع **نمایش** انجام میشه، پس
// هر کس با زبان خودش می‌بینه.
//
// چرا نشانه‌ی متنی توی همون ستون و نه ستون‌های تازه: مهاجرت لازم نداره و
// ردیف‌های قدیمی هم نمی‌شکنن — هر چیزی که با `@` شروع نشه، متنِ آزادِ کاربر
// (یا داده‌ی قدیمی) حساب میشه و همون‌طور که هست نشون داده میشه.
// این فایل عمداً **هیچ** ایمپورتی نداره. لحظه‌ای که `./i18n` رو وارد کنه،
// دیگه با `npm test` بالا نمیاد چون i18n به react و AsyncStorage وابسته‌ست.
// ترجمه‌ش توی core/lib/approxLabel.ts انجام میشه.

/** خوانشِ نشانه، جدا از هر ترجمه‌ای — تا بشه بدون react-native تستش کرد. */
export type Approx =
  | { kind: 'preset'; key: string }
  | { kind: 'around'; dow: number; hour: number }
  | { kind: 'raw'; text: string };

/** گزینه‌های آماده‌ی «کِی؟». مقدارشون همونیه که توی دیتابیس می‌شینه. */
export const APPROX_PRESETS = [
  { token: '@weekend', key: 'whenThisWeekend' },
  { token: '@tonight', key: 'whenTonight' },
  { token: '@friday', key: 'whenFriday' },
  { token: '@next_week', key: 'whenNextWeek' },
] as const;

/** «حدودِ فلان روز ساعت فلان» — از پیشنهادِ وقتِ مشترک میاد. */
export const aroundToken = (dow: number, hour: number): string => `@around:${dow}:${hour}`;

/**
 * نشانه رو می‌خونه. هر ورودیِ ناشناخته `raw` میشه؛ این عمدیه و ردیف‌های قبل از
 * این تغییر رو زنده نگه می‌داره.
 */
export function parseApprox(label?: string | null): Approx {
  const text = label ?? '';
  if (!text.startsWith('@')) return { kind: 'raw', text };

  const preset = APPROX_PRESETS.find((p) => p.token === text);
  if (preset) return { kind: 'preset', key: preset.key };

  const m = text.match(/^@around:(\d+):(\d+)$/);
  // شماره‌ی روزِ بی‌ربط رو `raw` می‌کنیم تا به‌جای «undefined» خودِ نشانه دیده شه —
  // زشت‌تر ولی صادق‌تر.
  if (m && Number(m[1]) >= 0 && Number(m[1]) < 7) {
    return { kind: 'around', dow: Number(m[1]), hour: Number(m[2]) };
  }
  return { kind: 'raw', text };
}
